import type { ChartSeriesBuilderMisc } from "./types";
import { countSuffix } from "./countSpec.mjs";

// Series-label formatting shared by the chart/pie/table builders and their widgets.
// (Previously lived in buildRaw.ts, a bar-chart config builder, despite being a
// generic label util imported by 7 modules.)

const AGG_DISPLAY: Record<string, string> = { avg: "A", sum: "C", best: "B" };

export function formatSubjectNames(names: string[] | undefined): string {
  if (!names || names.length === 0) return "";
  const MAX_INLINE = 2;
  if (names.length <= MAX_INLINE) return names.join(", ");
  return `${names.slice(0, MAX_INLINE).join(", ")} (+${names.length - MAX_INLINE} more)`;
}

export function formatSeriesLabel(
  metricName: string,
  metricAgg: string,
  metricIdentifierType: string,
  misc?: Pick<ChartSeriesBuilderMisc, "selectedSubjectNames" | "selectedSubjects" | "countSpec">,
): string {
  const isAcwr = metricIdentifierType === "acwr";
  const isCount = metricIdentifierType === "count";
  // A count always totals, so the "[C]" aggregate prefix says nothing a reader needs —
  // the metric name already reads "# of Flags". What does need saying is which items
  // it counts, and the match mode when it is not the default.
  const prefix = isAcwr ? "ACWR" : (isCount ? "" : (AGG_DISPLAY[metricAgg] ?? ""));
  // Strip redundant "(ACWR)" suffix that plotState bakes into displayName
  const cleanName = isAcwr ? metricName.replace(/\s*\(ACWR\)$/i, "") : metricName;
  const subjects = misc?.selectedSubjectNames ?? [];
  const subjectSuffix = formatSubjectNames(subjects.length > 0 ? subjects : undefined);
  const withCount = isCount ? `${cleanName}${countSuffix(misc?.countSpec)}` : cleanName;
  const base = prefix ? `[${prefix}] ${withCount}` : withCount;
  return subjectSuffix ? `${base} | ${subjectSuffix}` : base;
}
